import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import errorBoundary from '@ifeng/errorBoundary';
import SiderTopic from '../../../components/siderTopic';
import NewsSiderContent from '../../../components/newsSiderContent';

class VSNewsSider extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const {
            content: { vsNewsSiderTitle, vsNewsSiderTips, vsNewsSiderContent0, vsNewsSiderContent1 },
        } = this.props;

        return (
            <div className={styles.sider_box}>
                <div id="vipSiderList" className={styles.sider}>
                    <Chip id="50086" type="struct" title="市场部标题" groupName="市场部" content={vsNewsSiderTitle}>
                        <SiderTopic />
                    </Chip>
                    <p className={styles.title}>{vsNewsSiderTips[0]}</p>
                    <Chip
                        id="75127"
                        type="recommend"
                        title="市场部列表"
                        groupName="市场部"
                        content={vsNewsSiderContent0}
                        translate="handleNewsSiderContentData"
                        translateOptions={{ index: -1 }}>
                        <NewsSiderContent />
                    </Chip>
                    <p className={styles.title}>{vsNewsSiderTips[1]}</p>
                    <Chip
                        id="75128"
                        type="recommend"
                        title="市场部列表"
                        groupName="市场部"
                        content={vsNewsSiderContent1}
                        translate="handleNewsSiderContentData"
                        translateOptions={{ index: -1 }}>
                        <NewsSiderContent />
                    </Chip>
                </div>
            </div>
        );
    }
}

export default errorBoundary(VSNewsSider);
